<script setup lang="ts">
/**
 * Edición del perfil del centro: el mismo wizard del alta, sembrado con el
 * centro actual.
 *
 * No tiene item en el menú lateral —se entra por "Edit profile" del Overview—,
 * así que sin `navActiveLink` el grupo de Dive Centers se cerraría al entrar:
 * `isNavLinkActive` compara por nombre de ruta y ninguno de sus items matchea.
 */
import DiveCenterWizard from '@/components/DiveCenterWizard.vue'
import { useDiveCenterProfile } from '@/composables/useDiveCenterProfile'

definePage({ meta: { requiresAuth: true, centerConfig: true, navActiveLink: 'dive-centers-id' } })

const { diveCenter, applyDiveCenter } = useDiveCenterProfile()
</script>

<template>
  <DiveCenterWizard
    v-if="diveCenter"
    :dive-center="diveCenter"
    @updated="applyDiveCenter"
  />
</template>
